// src/components/MfaModal.js

import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

// Componente para o nosso modal de verificação MFA
function MfaModal({ show, onHide, onSubmit, phoneNumberHint, isVerifying }) {
    const [code, setCode] = useState(new Array(6).fill(''));
    const inputsRef = useRef([]);

    // Reseta o código quando o modal é fechado/aberto
    useEffect(() => {
        if (show) {
            setCode(new Array(6).fill(''));
            inputsRef.current[0]?.focus();
        }
    }, [show]);

    const handleChange = (element, index) => {
        if (isNaN(element.value)) return false; // Apenas números

        // Atualiza o estado com o novo dígito
        const newCode = [...code];
        newCode[index] = element.value;
        setCode(newCode);

        // Foca no próximo input
        if (element.nextSibling) {
            element.nextSibling.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        // Move o foco para o input anterior ao pressionar backspace
        if (e.key === 'Backspace' && !code[index] && e.target.previousSibling) {
            e.target.previousSibling.focus();
        }
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        onSubmit(code.join(''));
    };
    
    // Estilos para os inputs do código
    const inputStyle = {
        width: '45px',
        height: '50px',
        textAlign: 'center',
        fontSize: '1.5rem',
        margin: '0 5px',
        borderRadius: '8px',
        border: '1px solid #ced4da'
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Body className="text-center p-5">
                <div 
                    className="d-flex justify-content-center align-items-center mb-4"
                    style={{ 
                        width: '60px', 
                        height: '60px', 
                        borderRadius: '50%', 
                        backgroundColor: '#e7f0ff',
                        margin: '0 auto' 
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#0d6efd" className="bi bi-envelope-fill" viewBox="0 0 16 16">
                      <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"/>
                    </svg>
                </div>

                <h4 className="fw-bold">Verifique seu celular</h4>
                <p className="text-muted mb-4">
                    Digite o código de verificação enviado para o número que termina em {phoneNumberHint}
                </p>

                <Form onSubmit={handleFormSubmit}>
                    <div className="d-flex justify-content-center mb-4">
                        {code.map((data, index) => (
                            <Form.Control
                                key={index}
                                style={inputStyle}
                                type="text"
                                maxLength="1"
                                value={data}
                                onChange={e => handleChange(e.target, index)}
                                onKeyDown={e => handleKeyDown(e, index)}
                                onFocus={e => e.target.select()}
                                ref={el => inputsRef.current[index] = el}
                                disabled={isVerifying}
                            />
                        ))}
                    </div>
                    <p className="text-muted">
                        Não recebeu o código? <a href="#resend" onClick={(e) => e.preventDefault()}>Reenviar</a>
                    </p>
                    <Button variant="primary" type="submit" className="w-100" disabled={isVerifying || code.join('').length < 6}>
                        {isVerifying ? 'Verificando...' : 'Verificar'}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default MfaModal;